export const baseUnitPx = 8;
export const spacing = (factor: number): string => `${baseUnitPx * factor}px`;

const responsiveUnit = {
  xs: 2,
  sm: 2,
  md: 2,
  lg: 5,
  xl: 5,
};

export const namedSpacingsMap = {
  gridGapXs: responsiveUnit.xs,
  gridGapSm: responsiveUnit.sm,
  gridGapMd: responsiveUnit.md,
  gridGapLg: responsiveUnit.lg,
  gridGapXl: responsiveUnit.xl,
  headerHeightXs: 7,
  headerHeightSm: 7,
  headerHeightMd: 9,
  headerHeightLg: 9,
  headerHeightXl: 11,
} as const;

export type NamedSpacing = keyof typeof namedSpacingsMap;

export const getNamedSpacing = (spacingName: NamedSpacing): number => namedSpacingsMap[spacingName];
export const getParsedNamedSpacing = (spacingName: NamedSpacing): string =>
  spacing(namedSpacingsMap[spacingName]);

export const MaxWidth = 1500;
